import { useQuery } from 'react-query';

import { FEATURE_FLAGS_FOR_SELLER } from '@savgroup-front-common/constants';

import useToasts from '../../molecules/NotificationsProvider/ToastsProvider/hooks/useToasts';

import getFeatureFlagsQuery from './getFeatureFlagsQuery';

export const useGetEnabledFeatureFlagsQuery = ({
  sellerId,
  enabled = true,
  suspense = false,
}: {
  sellerId: string;
  enabled?: boolean;
  suspense?: boolean;
}): FEATURE_FLAGS_FOR_SELLER[] => {
  const { pushErrors } = useToasts();

  const { data } = useQuery(
    ['useGetEnabledFeatureFlagsQuery', { sellerId }],
    async () => {
      const response = await getFeatureFlagsQuery({
        sellerId,
      });

      if (response.failure) {
        pushErrors(response.errors);

        return [];
      }

      return response.value ?? [];
    },
    { staleTime: Infinity, suspense, enabled },
  );

  return (
    data
      ?.filter((featureFlag) => featureFlag.value)
      .map((featureFlag) => featureFlag.key) ?? []
  );
};
